import dayjs from 'dayjs';
import _ from 'lodash';
import { FlightSearchTypes, InitialFormValidations } from '../../../../constants';

const validateFlightSearchInputs = (
  setFormValidations,
  leadDays,
  flightSearchType,
  searchInputs,
  doShowValidationErrors = true,
  isCheckAvailability = false,
  segmentIndex,
) => {
  const validationObj = JSON.parse(JSON.stringify(InitialFormValidations));
  const isDirectSell = flightSearchType === FlightSearchTypes.DIRECT_SELL;
  const reasons = [];
  let failedSegmentIndex;
  if (!searchInputs) return { isValid: false, reasons: ['searchInputsMissing'] };
  if (!searchInputs.flightSegments || !searchInputs.flightSegments.length) {
    validationObj.flightSegments[0] = {
      origin: 'Flight origin is required.',
    };
    reasons.push('segmentsMissing');
  } else if (
    searchInputs.flightSegments.length === 1 &&
    flightSearchType === FlightSearchTypes.MULTI_CITY
  ) {
    validationObj.flightSegments[1] = {
      origin: 'Flight destination is required.',
    };
    reasons.push('destinationSegmentMissing');
  }
  const start = isCheckAvailability ? segmentIndex : 0;
  const end = isCheckAvailability ? segmentIndex + 1 : searchInputs.flightSegments.length;
  for (let index = start; index < end; index += 1) {
    const fs = searchInputs.flightSegments[index];
    if (searchInputs.flightSearchType === FlightSearchTypes.ROUND_TRIP && index > 0) {
      if (!fs.leaveDate) {
        validationObj.flightSegments[index] = {
          returnDate: 'Return date is required.',
        };
        reasons.push('returnDateMissing');
        failedSegmentIndex = index;
      }
      break;
    }
    if (!fs.origin || (!fs.origin.airportCode && !fs.origin.value)) {
      validationObj.flightSegments[index] = {
        origin: 'Flight origin is required.',
      };
      reasons.push('originMissing');
      failedSegmentIndex = index;
      break;
    } else if (
      !fs.destination ||
      (!fs.destination.airportCode &&
        !fs.destination.value &&
        !(fs.destination.latitude && fs.destination.longitude))
    ) {
      validationObj.flightSegments[index] = {
        destination: 'Flight destination is required.',
      };
      reasons.push('destinationMissing');
      failedSegmentIndex = index;
      break;
    } else if (!fs.leaveDate && !isDirectSell) {
      validationObj.flightSegments[index] = {
        leaveDate: 'Leave date is required.',
      };
      reasons.push('leaveDateMissing');
      failedSegmentIndex = index;
      break;
    }

    // Lead day validations based on user status
    const today = dayjs().startOf('day');
    const minCheckInDate = today.add(leadDays, 'day');

    if (isDirectSell) {
      if (_.isEmpty(fs.departureDate)) {
        validationObj.flightSegments[index] = { departureDate: 'Departure date is required' };
        reasons.push('departureDateMissing');
        failedSegmentIndex = index;
        break;
      } else if (dayjs(fs.departureDate).isBefore(today)) {
        validationObj.flightSegments[index] = {
          departureDate: 'Departure date cannot be earlier than today',
        };
        reasons.push('departureDateBeforeToday');
        failedSegmentIndex = index;
        break;
      } else if (dayjs(fs.departureDate).isBefore(minCheckInDate)) {
        validationObj.flightSegments[index] = {
          departureDate: `Departure date cannot be earlier than ${leadDays} ${leadDays === 1 ? 'day' : 'days'} from today.`,
        };
        reasons.push('departureDateBeforeLeadDays');
        failedSegmentIndex = index;
        break;
      } else if (_.isEmpty(fs.carrierCode)) {
        validationObj.flightSegments[index] = { carrierCode: 'Airline code is required' };
        reasons.push('carrierCodeMissing');
        failedSegmentIndex = index;
        break;
      } else if (_.isEmpty(fs.flightNumber)) {
        validationObj.flightSegments[index] = { flightNumber: 'Flight number is required' };
        reasons.push('flightNumberMissing');
        failedSegmentIndex = index;
        break;
      } else if (_.isEmpty(fs.cabin) && !isCheckAvailability) {
        validationObj.flightSegments[index] = { cabin: 'Cabin is required' };
        reasons.push('cabinMissing');
        failedSegmentIndex = index;
        break;
      }
    } else {
      if (dayjs(fs.leaveDate).isBefore(today)) {
        validationObj.flightSegments[index] = {
          leaveDate: 'Leave date cannot be earlier than today',
        };
        reasons.push('leaveDateBeforeToday');
        failedSegmentIndex = index;
        break;
      }
      if (dayjs(fs.leaveDate).isBefore(minCheckInDate)) {
        validationObj.flightSegments[index] = {
          leaveDate: `Leave date cannot be earlier than ${leadDays} ${leadDays === 1 ? 'day' : 'days'} from today.`,
        };
        reasons.push('leaveDateBeforeLeadDays');
        failedSegmentIndex = index;
        break;
      }
    }
  }

  if (doShowValidationErrors) setFormValidations(validationObj);
  return { isValid: reasons.length === 0, reasons, failedSegmentIndex };
};

export default validateFlightSearchInputs;
